//-----------------------------------------------------------------------------
//  Copyright (c) 2019 by Dell Inc.
//
// All rights reserved.  This software may not be copied, disclosed,
// transferred, or used except in accordance with a license granted
// by Dell Inc.  This software embodies proprietary information
// and trade secrets of Dell Inc.
//
//-----------------------------------------------------------------------------

import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { defaultTheme } from '../../config/theming';
import { FilledInfoIcon } from '../icons';

const Container = styled.div<{ color: string; bgColor: string }>`
  display: flex;
  flex-direction: row;
  color: ${p => p.color || ''};
  align-items: center;
  background-color: ${p => p.bgColor || defaultTheme.colors.white};
  width: 100%;
  height: 64px;
  min-height: 64px;
  margin-bottom: 20px;
  padding: 0 16px;
  box-shadow: 0 0 1px 1px rgba(173, 173, 173, 0.2);
`;

const IconButtonWrapper = styled.div<{ color: string }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: ${p => p.color};
  fill: ${p => p.color};
  align-items: center;
`;

const ButtonWrapper = styled.div`
  font-size: 16px;
  margin-left: 16px;
  & button {
    min-width: 112px;
  }
`;

const Message = styled.p<{ textColor: string }>`
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 0 16px;
  color: ${p => p.textColor || ''};
  padding: 0;
`;

interface NotificationProps {
  button: ReactNode;
  message: string;
  bgColor?: string;
  iconColor?: string;
  textColor?: string;
}

const Notification = (props: NotificationProps) => {
  return (
    <Container color={props.textColor || ''} bgColor={props.bgColor || ''}>
      <IconButtonWrapper color={props.iconColor || ''}>
        <FilledInfoIcon></FilledInfoIcon>
        <ButtonWrapper>{props.button}</ButtonWrapper>
      </IconButtonWrapper>
      <Message textColor={props.textColor || ''}>{props.message}</Message>
    </Container>
  );
};

export { Notification };
